export default "__VITE_ASSET__D$CLz4JS__"